import React from "react";
import { Form } from "react-bootstrap";

export class HandledError extends Error {}

export const parseFieldsError = (error) => {
	const fieldErrors = {};

	const data = error.data;
	if (!data) {
		console.error("Unexpected error: no data found");
		return fieldErrors;
	}

	data.forEach((fieldError) => {
		fieldErrors[fieldError.path] = fieldError.message;
	});

	return fieldErrors;
};

export const fieldErrorRenderer = (error, errorStyles) => {
	return (field) => {
		if (!error) return;

		if (!field) {
			console.error("Unexpected field");
			return;
		}

		const fieldError = error[field];
		if (!fieldError) {
			return;
		}

		return <Form.Text style={{ color: "red" }}>{fieldError}</Form.Text>;
	};
};
